import React, {Component} from 'react';
import {observer} from "mobx-react";
import GridGallery from "../../Helpers/GridGallery/GridGallery";
import AttachmentSpoiler from "./AttachmentSpoiler";
import LazyBlock from "../../Helpers/LazyBlock";


class Gallery extends Component {
  isOne() {
    return this.props.data.gallery && this.props.data.gallery.length == 1;
  }
  render() {
    if(this.props.data.spoiler && !this.props.data.show_spoiler) {
      return (
        <AttachmentSpoiler data={this.props.data} />
      )
    }
    return (
      <div style={{maxWidth:'100%', width: this.isOne()?400:'auto'}} className="center pr tac">
        <GridGallery listMode={this.isOne()?"chat":"grid"} items={this.props.data.gallery} index="path" />
      </div>
    )
  }
}

export default observer(Gallery);